import React from 'react'
import Headerbar  from "./components/common/Headerbar";
import Titlebar  from "./components/common/Titlebar";
import PaymentRequestForm from "./components/payment_approval/PaymentRequestForm";

function PaymentRequest() {
  return (
    <><Headerbar /><Titlebar name="Payment request form" /><PaymentRequestForm /></>
  )
}

export default PaymentRequest